import TopHeadScreen from "../../component/layout/tophead";
import SidebarScreen from "../../component/layout/sidebar";
import AuthFooterScreen from "../../component/layout/authfooter";
import Button from "react-bootstrap/Button";
import { LuPencilLine } from "react-icons/lu";
import { FiPlus } from "react-icons/fi";
import { FiMoreVertical } from "react-icons/fi";
import Dropdown from "react-bootstrap/Dropdown";
import NavItem from "react-bootstrap/NavItem";
import NavLink from "react-bootstrap/NavLink";
import { MdDeleteOutline } from "react-icons/md";

import { HiOutlineLightBulb } from "react-icons/hi";
import { FaCheck } from "react-icons/fa6";
import { SlGraduation } from "react-icons/sl";
import { LiaAwardSolid } from "react-icons/lia";
import { useEffect, useState } from "react";
import { useCustomNavigate } from "../../hooks/useCustomNavigate";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { AppRoute } from "../../router/routerConstants";
import moment from "moment";
import AddEducationModal from "./common/add-education-modal";
import { setResumeDetails } from "../../store/resume.store";
import AgentSidebarScreen from "../../component/layout/agent-sidebar";
import AgentTopHeadScreen from "../../component/layout/agent-header";

interface Education {
  from: Date | null;
  to: Date | null;
  fieldofstudy: string;
  degree: string;
  college: string;
  city: string;
}

interface Educations {
  educations: Education[];
}
const ResumeAfterAddedEducationInformationScreen = () => {
  const [showEXP, setShowEXP] = useState(false);
  const handleCloseEXP = () => setShowEXP(false);
  const [isBulkEdit, setIsBulkEdit] = useState(false);
  const [isSingleEdit, setIsSingleEdit] = useState(false);
  const dispatch = useDispatch();

  const defaultEducations = {
    educations: [
      {
        from: null,
        to: null,
        fieldofstudy: "",
        degree: "",
        college: "",
        city: "",
      },
    ],
  };
  const [educationList, setEducationList] =
    useState<Educations>(defaultEducations);
  const [NavigateTo] = useCustomNavigate();
  const { resumeDetails } = useSelector(
    (state: RootState) => state.resumeSlice
  );
  const { user } = useSelector((state: RootState) => state.authSlice);
  const isBulkEditHandler = () => {
    setIsBulkEdit(false);
    setIsSingleEdit(false);
    setShowEXP(true);
  };

  const isSingleEditHandler = (item: Education) => {
    setIsSingleEdit(true);
    setIsBulkEdit(false);
    setShowEXP(true);
    setEducationList({ educations: [item] });
  };

  const isSingleDeleteHandler = (index: number) => {
    if (!resumeDetails?.educations) return;

    const updatedEducations = resumeDetails?.educations?.filter(
      (_, i) => i !== index
    );
    dispatch(
      setResumeDetails({ ...resumeDetails, educations: updatedEducations })
    );
  };

  useEffect(() => {
    if (resumeDetails?.educations && resumeDetails?.educations?.length < 1) {
      if (user && user?.role === "jobseeker") {
        NavigateTo(AppRoute.JOBSEEKER_EDUCATION);
      } else if (user && user?.role === "localagents") {
        NavigateTo(AppRoute.AGENT_EDUCATION);
      }
    }
    // eslint-disable-next-line
  }, [resumeDetails]);

  const nextHandler = () => {
    if (user && user?.role === "jobseeker") {
      if (
        resumeDetails?.achievements &&
        resumeDetails?.achievements?.length > 0
      )
        NavigateTo(AppRoute.JOBSEEKER_AFTER_ADDED_ACHIEVEMENTS);
      else NavigateTo(AppRoute.JOBSEEKER_ACHIEVEMENTS);
    } else if (user && user?.role === "localagents") {
      if (
        resumeDetails?.achievements &&
        resumeDetails?.achievements?.length > 0
      )
        NavigateTo(AppRoute.AGENT_AFTER_ADDED_ACHIEVEMENTS);
      else NavigateTo(AppRoute.AGENT_ACHIEVEMENTS);
    }
  };
  const prevHandler = () => {
    if (user && user?.role === "jobseeker") {
      if (resumeDetails?.educations && resumeDetails?.educations?.length > 0)
        NavigateTo(AppRoute.JOBSEEKER_ADDED_WORK_EXPERIENCE);
      else NavigateTo(AppRoute.JOBSEEKER_EDUCATION);
    } else if (user && user?.role === "localagents") {
      if (resumeDetails?.educations && resumeDetails?.educations?.length > 0)
        NavigateTo(AppRoute.AGENT_ADDED_WORK_EXPERIENCE);
      else NavigateTo(AppRoute.AGENT_EDUCATION);
    }
  };

  return (
    <>
      <div className="main">
        <section className="profileJobDetails-area">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-2 sidebar  position-relative p-0">
                {user && user?.role === "jobseeker" && <SidebarScreen />}
                {user && user?.role === "localagents" && (
                  <AgentSidebarScreen />
                )}{" "}
              </div>
              <div className="col-lg-10 rightcontent p-0">
                {user && user?.role === "jobseeker" && <TopHeadScreen />}
                {user && user?.role === "localagents" && (
                  <AgentTopHeadScreen />
                )}{" "}
                <div className="profile-account-details-holder rightInnerScroll common-padd-lt-rt ">
                  <div className="row">
                    <div className="col-lg-12 mb-4">
                      <div className="profile-account-details">
                        <div className="row">
                          <div className="col-lg-12">
                            <div className="title">
                              <h2>My Resume</h2>
                            </div>
                          </div>
                          <div className="col-lg-12">
                            <div className="myResume-holder">
                              <div className="login-form-area add-password-form mt-5">
                                <div className="stepbar">
                                  <ul>
                                    <li className="checked">
                                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid  */}
                                      <a href="#">
                                        <div className="icon-progress">
                                          <span>
                                            <FaCheck />
                                          </span>
                                        </div>
                                        <p>Step 1</p>
                                        <h4>About You</h4>
                                      </a>
                                    </li>
                                    <li className="checked">
                                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid  */}
                                      <a href="#">
                                        <div className="icon-progress">
                                          <span>
                                            <FaCheck />
                                          </span>
                                        </div>
                                        <p>Step 2</p>
                                        <h4>Experience</h4>
                                      </a>
                                    </li>
                                    <li className="inprogress">
                                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid  */}
                                      <a href="#">
                                        <div className="icon-progress">
                                          <span>
                                            <SlGraduation />
                                          </span>
                                        </div>
                                        <p>Step 3</p>
                                        <h4>Education</h4>
                                      </a>
                                    </li>
                                    <li className="">
                                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid  */}
                                      <a href="#">
                                        <div className="icon-progress">
                                          <span>
                                            <LiaAwardSolid />
                                          </span>
                                        </div>
                                        <p>Step 4</p>
                                        <h4>Achievements</h4>
                                      </a>
                                    </li>
                                    <li className="">
                                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid  */}
                                      <a href="#">
                                        <div className="icon-progress">
                                          <span>
                                            <HiOutlineLightBulb />
                                          </span>
                                        </div>
                                        <p>Step 5</p>
                                        <h4>Skills</h4>
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </div>

                              <div className="comnbrdrGap profileEdit mb-4">
                                <div className="d-flex">
                                  <h3>My Education</h3>
                                  <button
                                    className="editbtn"
                                    onClick={isBulkEditHandler}
                                  >
                                    <FiPlus /> Add
                                  </button>
                                </div>
                                {resumeDetails?.educations &&
                                  resumeDetails?.educations?.map(
                                    (item: any, index: number) => {
                                      return (
                                        <div
                                          className="moreedit-holder"
                                          key={index}
                                        >
                                          <div className="d-flex">
                                            <h6>
                                              {moment(item?.from).format(
                                                "MMMM YYYY"
                                              )}{" "}
                                              -{" "}
                                              {moment(item?.to).format(
                                                "MMMM YYYY"
                                              )}
                                            </h6>
                                            <Dropdown
                                              as={NavItem}
                                              className="editnow"
                                            >
                                              <Dropdown.Toggle
                                                className="profiledropdown"
                                                as={NavLink}
                                              >
                                                <FiMoreVertical />
                                              </Dropdown.Toggle>
                                              <Dropdown.Menu>
                                                <Dropdown.Item
                                                  className=""
                                                  onClick={() =>
                                                    isSingleEditHandler(item)
                                                  }
                                                >
                                                  <LuPencilLine /> Edit
                                                </Dropdown.Item>
                                                <Dropdown.Item
                                                  onClick={() =>
                                                    isSingleDeleteHandler(index)
                                                  }
                                                >
                                                  <MdDeleteOutline /> Delete
                                                </Dropdown.Item>
                                              </Dropdown.Menu>
                                            </Dropdown>
                                          </div>
                                          <h6>
                                            {item?.fieldofstudy} -{" "}
                                            <span> {item?.degree}</span>
                                          </h6>
                                          <p>
                                            {item?.college}, {item?.city}
                                          </p>
                                        </div>
                                      );
                                    }
                                  )}
                              </div>
                              <div className="flex-btn d-flex">
                                <Button
                                  className="btn btn-primary"
                                  onClick={prevHandler}
                                  // href="/jobseeker/my-resume"
                                >
                                  Prev
                                </Button>
                                <Button
                                  className="btn btn-primary"
                                  onClick={nextHandler}
                                  // href="/jobseeker/resume-achievements-information"
                                >
                                  Next
                                </Button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <AuthFooterScreen />

      {/* Add Work Experience Modal */}
      <AddEducationModal
        show={showEXP}
        onClose={handleCloseEXP}
        isBulkEdit={isBulkEdit}
        isSingleEdit={isSingleEdit}
        getEducationList={educationList}
      />
      {/* Add Work Experience Modal */}
    </>
  );
};
export default ResumeAfterAddedEducationInformationScreen;
